import { render, staticRenderFns } from "./VlLastActionFilter.vue?vue&type=template&id=384ee030&scoped=true&"
import script from "./VlLastActionFilter.vue?vue&type=script&lang=js&"
export * from "./VlLastActionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384ee030",
  null
  
)

export default component.exports